/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminSearchConfiguration
 */
export interface AdminSearchConfiguration {
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminSearchConfiguration
     */
    noResultMessages: Array<string>;
}

/**
 * Check if a given object implements the AdminSearchConfiguration interface.
 */
export function instanceOfAdminSearchConfiguration(value: object): value is AdminSearchConfiguration {
    if (!('noResultMessages' in value) || value['noResultMessages'] === undefined) return false;
    return true;
}

export function AdminSearchConfigurationFromJSON(json: any): AdminSearchConfiguration {
    return AdminSearchConfigurationFromJSONTyped(json, false);
}

export function AdminSearchConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminSearchConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'noResultMessages': json['noResultMessages'],
    };
}

export function AdminSearchConfigurationToJSON(value?: AdminSearchConfiguration | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'noResultMessages': value['noResultMessages'],
    };
}

